import {
    Box,
    Grid,
    MenuItem,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttFormCheck } from '../../../sporttia/all';

interface BookingSectionGamesProps {
    level: string;
    gender: string;
    privateGame: boolean;
    onChangeLevel: (value: string) => void;
    onChangeGender: (value: string) => void;
    onChangePrivateGame: (value: boolean) => void;
}

export default function BookingSectionGames({
    level,
    gender,
    privateGame,
    onChangeLevel,
    onChangeGender,
    onChangePrivateGame,
}: BookingSectionGamesProps) {
    const { t } = useTranslation();

    return (
        <Box mt={3}>
            <Paper>
                <Box p={3}>
                    <Box mb={2}>
                        <Typography variant="h6">{t('gamesData')}</Typography>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label={t('Level')}
                                value={level}
                                onChange={(e: any) =>
                                    onChangeLevel(e.target.value)
                                }
                                placeholder={t('form.example', {
                                    value: '3.50',
                                })}
                                fullWidth
                                required
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                helperText={t('games.skillScaleInfo')}
                                inputProps={{
                                    min: 0,
                                    step: 0.01,
                                    inputMode: 'decimal',
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                select
                                label={t('Gender')}
                                value={gender}
                                onChange={(e: any) =>
                                    onChangeGender(e.target.value)
                                }
                                fullWidth
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                <MenuItem value="MALE">{t('G.MALE')}</MenuItem>
                                <MenuItem value="FEMALE">
                                    {t('G.FEMALE')}
                                </MenuItem>
                                <MenuItem value="MIX">
                                    {t('const.TT.MIX')}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <SttFormCheck
                            name="privateGame"
                            grid
                            caption={t('makeGamePublic')}
                            checked={!privateGame}
                            onChange={({ value }: any) =>
                                onChangePrivateGame(!value)
                            }
                        />
                    </Grid>
                </Box>
            </Paper>
        </Box>
    );
}
